module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAPFBMVEUVqfEUqPD///8eq/AlrvHQ7fyn3vmG0vdvyvVgxPUXqfDX8PzI6vvE6fvC6Puw4vp+z/Z3zPZZwfQ0s/Kp/+WVAAAAAXRSTlO1++2fZQAAAE1JREFUGNOVjzcOACEMBM3axMvH//8KBQjcILGFJU+xgcgo9X9oD8SsgYdX4MXFDXCs58PJ3eOHMwGWh6nDDStTSnpwiIpNQbaarudSAf6VAeJGJvYnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/checked.png
// module id = Q9at
// module chunks = 2